<template>
  <component
    :is="tag"
    :class="classes"
    v-html="content"
    :role="role"
    :size="size"
  >
  </component>
</template>

<script setup lang="ts">
import './Heading.scss';
import { computed } from 'vue';
export type HeadingColor =
  | ''
  | 'black'
  | 'white'
  | 'magenta'
  | 'blue'
  | 'green';
export interface HeadingProps {
  role?: 'display' | 'headline' | 'title' | 'label' | 'body' | 'extra';
  size?: 'small' | 'medium' | 'large';
  color?: HeadingColor;
  align?: '' | 'left' | 'center' | 'right';
  transform?: '' | 'lower' | 'upper';
  tag?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'span';
  content?: string;
  status?: '' | 'green' | 'red' | 'grey';
  class?: string;
}

const props = withDefaults(defineProps<HeadingProps>(), {
  role: 'headline',
  size: 'small',
  color: '',
  align: '',
  transform: '',
  tag: 'h1',
  content: '',
  status: '',
  class: '',
});

const classes = computed(() => ({
  heading: true,
  [`role-${props.role}`]: true,
  [`size-${props.size}`]: true,
  [`color-${props.color}`]: props.color !== '',
  [`align-${props.align}`]: props.align !== '',
  [`text-${props.transform}`]: props.transform !== '',
  [`status-${props.status}`]: props.status !== '',
  [`${props.class}`]: props.class !== '', // I added this to have a way to add extra classes on demand
}));
</script>
